import { z } from 'zod';
import { Field, MemberSearchResult, SignedUrlResponse, TodayBoard, TodayBoardRow, TodayLiveMessage } from '@cloudsign/shared';
import type { TodayBoard as TodayBoardT, TodayBoardRow as TodayBoardRowT } from '@cloudsign/shared';
import { api } from '../../lib/api';

export const MemberSearch = MemberSearchResult;
export const FieldList = z.array(Field);
export const FileUrl = SignedUrlResponse;

export const boardKey = (siteId: string | null) => ['today', 'board', siteId] as const;

export function fetchBoard(siteId: string): Promise<TodayBoardT> {
  return api.get('/visits/today', { query: { siteId, show: 'all' }, schema: TodayBoard });
}

/** Applies one live message to the cached board. Messages are idempotent upserts by id. Returns null when a refetch is needed. */
export function applyLive(board: TodayBoardT, data: unknown): TodayBoardT | null {
  const parsed = TodayLiveMessage.safeParse(data);
  if (!parsed.success) return null;
  const m = parsed.data;
  if (m.type === 'refresh') return null;
  if (m.type === 'visit.remove') return { ...board, rows: board.rows.filter((r) => r.id !== m.id) };
  const exists = board.rows.some((r) => r.id === m.row.id);
  const rows: TodayBoardRowT[] = exists ? board.rows.map((r) => (r.id === m.row.id ? m.row : r)) : [m.row, ...board.rows];
  return { ...board, rows };
}

/** Every open (signed-in, not signed-out) row. */
export const isIn = (r: TodayBoardRowT): boolean => r.signedOutAt === null;

export { TodayBoardRow };
